import type { FC } from "react";

import { DetailsBar } from "@jti/ui/components/DetailsBar";

import type { QuizBannerContent } from "../types";

import styles from "./QuizBannerTop.module.scss";

export type QuizBannerTopProps = {
  points: number | null;
  isCompleted: boolean | null;
  content: QuizBannerContent;
  onStart: () => void;
};

export const QuizBannerTop: FC<QuizBannerTopProps> = ({ points, isCompleted, content, onStart }) => {
  if (isCompleted) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <DetailsBar
        variant="compact"
        buttonVariant="primary"
        leftItem={points ?? 0}
        leftDescription={content.topBannerPointsLabel}
        rightTitle={content.topBannerTitle}
        buttonLabel={content.topBannerCta}
        buttonType="button"
        onButtonClick={onStart}
      />
    </div>
  );
};
